import axios from "axios";
import { getValidToken } from "./tokenManager";
import { handleResponseError } from "./httpErrorMapper";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getValidToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => {
    if (response.data && typeof response.data === "object") {
      try {
        JSON.stringify(response.data);
      } catch (_error) {
        return Promise.reject({
          message: "Resposta da API contem dados invalidos",
        });
      }
    }

    return response;
  },
  handleResponseError
);

export { API_BASE_URL };
export default apiClient;
